export default "PRODUCT_SEARCH_MODULE";
